
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic04Static as ObiHydraulic04StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-04-static.js';
 
 
 

 
 export const ObiHydraulic04Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-04-static',
   elementClass: ObiHydraulic04StaticElement,
   events: {
     
   }
  });
 
 